import script from "./FifthWheelSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FifthWheelSection.vue?vue&type=script&setup=true&lang=js"

import "./FifthWheelSection.vue?vue&type=style&index=0&id=6c7708d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7708d4"]])

export default __exports__